module.exports = ".iconsfooter {\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.contactusbtn {\n  background: transparent;\n  border: 1px solid red;\n  border-radius: 5px;\n  color: #ffffff;\n  margin-top: 2em;\n}\n\n.contactusbtn:hover {\n  background: transparent;\n  cursor: pointer;\n}\n\nfooter .casualtext:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.css
// module id = ./src/app/components/footer/footer.component.css
// module chunks = main